import {appCall, appSetObj, appSetVal, appSetServerVal, completeSession} from "../../../../store/application";
import {getData} from '../models/transaction';
import {changeStep} from "../../../../layouts/Content/modules/step";
import {STEPS} from '../../../../constants'
import {setLoadingContent} from "../../../../layouts/Content/modules/loadingContent";
import _ from 'lodash'
import _uploadPhoto from './uploadPhoto'
import _scanImages from './scanImages'

import {CASH_A_CHECK_TRANSACTION_STATUSES} from "../../../../constants";

import MAYA from '../../../../maya_api'

// ------------------------------------
// Actions
// ------------------------------------

function findAddress(query){
  return async (dispatch, getStore) => {
    await dispatch(appSetVal('s_customer_address', query));

    const result = await MAYA.findAddress(query);

    dispatch(appSetObj({
      customer_address_search_results: result
    }))
  }
}


function updateAmounts() {
  return (dispatch, getStore) => {
    dispatch(appCall('updateAmounts'))
  }
}

function uploadPhoto(photo) {
  return async(dispatch, getStore) => {

    await dispatch(appSetObj({
      photo_uploading_in_progress: true,
      image_path: '',
      image_file_path: '',
      image_path_original: ''
    }));

    _uploadPhoto(photo);
  }
}

function scanImages() {
  return async(dispatch, getStore) => {
    const scanner = getStore().scanner;

    _scanImages(scanner.imageFront, scanner.imageBack);

    await dispatch(resetCheckUploading());
    await dispatch(resetCheckResult());

    await dispatch(appSetObj({
      check_images_processing: true
    }));
  }
}

function createServiceCustomer(customer = {}) {
  return async(dispatch, getStore) => {
    const {s_customer_photo_path, s_customer_id_path_front, s_customer_id_path_back} = getStore().app.x_data;

    await dispatch(resetCustomerCreationErrors());

    await dispatch(appSetVal('create_customer_in_process', true));

    const result = await dispatch(appCall('createCustomer', _.extend(customer, {
      s_customer_photo_path,
      s_customer_id_path_front,
      s_customer_id_path_back
    })));

    await dispatch(appSetVal('create_customer_in_process', false));
  }
}

function resetCustomerCreationErrors(){
  return async(dispatch) => {
    await dispatch(appSetObj({
      s_customer_cell_phone_error: false,
      s_customer_email_error: false,
      s_customer_ssn_duplicated: false,
      s_customer_id_duplicated: false,
    }));
  }
}

function resetCustomer(){
  return async(dispatch, getStore) => {
    const data = getStore().app.x_data;

    let customerObj = {};

    for(let key in data){
      if(data.hasOwnProperty(key)){
        if(/s_customer_/.test(key)){
          customerObj[key] = '';
        }
      }
    }

    await dispatch(appSetObj(customerObj));
  }
}

function doCustomerSearch(){
  return async(dispatch, getStore) => {
    const term = getStore().app.x_data.customer_search_term;

    await dispatch(appSetVal('do_search_in_progress', true));

    await dispatch(appCall('doCustomerSearch', {query: term}, false));

    await dispatch(appSetVal('do_search_in_progress', false));
  }
}

function resetCheckResult() {
  return async(dispatch) => {
    await dispatch(appSetObj({
      check_date: "",
      check_maker_aba_number: "",
      check_maker_account_number: "",
      check_maker_address: "",
      check_maker_city: "",
      check_maker_name: "",
      check_maker_state: "",
      check_maker_zip: "",
      check_number: "",
      check_payee_name: "",
      check_raw_micr: "",
      create_check_done: false,
      create_check_success: false,

      check_amount: 0,
      original_amount: 0,
      customer_amount: 0,
      customer_balance_amount: 0,
      debit_amount: 0,
      fee: 0,
      selected_amount: 0,

      transaction_messages: [],
      transaction_status: ""
    }, true))
  }
}

function resetCheckUploading() {
  return async(dispatch) => {
    await dispatch(appSetObj({
      check_processing_success: false,
      check_processing_done: false,
      check_insert: false,
      check_removed: false,
      check_scan_back: false,
      check_scan_front: false,
      image_file_path_back: "",
      image_file_path_front: "",
      image_path_back: "",
      image_path_front: ""
    }, true))
  }
}

function createTransaction(values){
  return async(dispatch, getStore) => {
    dispatch(setLoadingContent(true));
    await dispatch(appCall('createTransaction', values));
    dispatch(setLoadingContent(false));
  }
}

function cancelTransaction() {
  return async(dispatch, getStore) => {
    dispatch(setLoadingContent(true));

    const { check_transaction_id } = getStore().app.x_data;
    if(!check_transaction_id) return fail();

    const result = await dispatch(appCall('cancelTransaction', {check_transaction_id: check_transaction_id}));
    if(!(result && result.cancel_transaction_success)){
      return fail();
    }

    return success();

    function success() {
      dispatch(setLoadingContent(false));
      dispatch(completeSession());
      return dispatch(changeStep(STEPS.CATEGORIES));
    }

    function fail() {
      dispatch(setLoadingContent(false));
      return false;
    }
  }
}

function approveTransaction() {
  return async(dispatch, getStore) => {
    dispatch(setLoadingContent(true));

    const { check_transaction_id, customer_amount } = getStore().app.x_data;
    if(!check_transaction_id) return fail();

    await dispatch(appSetObj({
      dispensed_amount: customer_amount,
      dispensable_amount: customer_amount
    }, true));

    const result = await dispatch(appCall('acceptTransaction'));
    if(!(result && result.accept_transaction_success)){
      return fail();
    }

    return success();

    function success() {
      dispatch(setLoadingContent(false));
      dispatch(completeSession());
      return dispatch(changeStep(STEPS.CATEGORIES));
    }

    function fail() {
      dispatch(setLoadingContent(false));
      return false;
    }
  }
}

function submitTransaction(dispatch){
  return async(dispatch, getStore) => {

  };
}


export {
  updateAmounts,
  submitTransaction,
  findAddress,
  createServiceCustomer,
  resetCustomer,
  doCustomerSearch,
  uploadPhoto,
  scanImages,
  resetCheckResult,
  resetCheckUploading,
  createTransaction,
  cancelTransaction,
  approveTransaction
};



// WEBPACK FOOTER //
// ./src/components/Applications/CheckCashing/modules/checkcashing.js